export default {
  global: {
    send: 'Odeslat',
    save: 'Uložit',
    confirm: 'Potvrdit',
    cancel: 'Zrušit',
    brand: 'HeiGIT - Heidelberg University',
    close: 'Zavřít',
    closeAndDoNotShowAgain: 'Zavřít a znovu nezobrazovat',
    select: 'Vybrat',
    yes: 'Ano',
    no: 'Ne',
    and: 'a',
    noAndDonAskAgain: 'NE (už se neptejte)',
    ok: 'OK',
    polygon: 'polygon',
    developedByIntro: 'Služby vyvinuté',
    developedBy: 'Heidelberským institutem pro geoinformační technologie',
    duration: 'Trvání',
    distance: 'Vzdálenost',
    elevation: 'Nadmořská výška',
    profile: 'Profil',
    options: 'Možnosti',
    parameters: 'Parametry',
    custom: 'Vlastní',
    customOverlayer: 'Vlastní překryvná vrstva',
    rawRouting: 'Hrubá navigace',
    months: {
      january: 'Leden',
      february: 'Únor',
      march: 'Březen',
      april: 'Duben',
      may: 'Květen',
      june: 'Červen',
      july: 'Červenec',
      august: 'Srpen',
      september: 'Září',
      october: 'Říjen',
      november: 'Listopad',
      december: 'Prosinec'
    },
    monthsShort: {
      january: 'Led',
      february: 'Úno',
      march: 'Bře',
      april: 'Dub',
      may: 'Kvě',
      june: 'Čer',
      july: 'Čvc',
      august: 'Srp',
      september: 'Zář',
      october: 'Říj',
      november: 'Lis',
      december: 'Pro'
    },
    units: {
      km: 'km(s)',
      mi: 'mi(s)',
      m: 'm',
      seconds: 'sekund',
      s: 's',
      minutes: 'minut',
      hours: 'hodin(a)',
      days: 'd',
      h: 'h',
      min: 'min',
      meters: 'metrů',
      lat: 'lat',
      lng: 'long',
      tones: 'tun',
      t: 't',
      kmh: 'km/h'
    },
    layers: {
      macrocounty: 'Region',
      country: 'Země',
      region: 'Kraj',
      county: 'Okres',
      macroregion: 'Makroregion',
      neighbourhood: 'Sousedství',
      locality: 'Lokalita',
      borough: 'Obec',
      localadmin: 'Místní správce',
      address: 'Adresa',
      street: 'Ulice',
      venue: 'Místo',
      rawCoordinate: 'hrubé lng,lat koordináty',
      notAvailable: 'Nedostupné',
      postalcode: 'PSČ',
      'undefined': 'Není definováno',
      ocean: 'Oceán'
    },
    population: 'Obyvatelstvo',
    green: 'Zelená',
    noise: 'Hluk',
    steepness: 'Strmost',
    surface: 'Povrch',
    roadaccessrestrictions: 'Omezení přístupu na silnice',
    waytypes: 'Typy cest',
    suitability: 'Vhodnost',
    waycategory: 'Kategorie cest',
    tollways: 'Mýtné brány',
    traildifficulty: 'Obtížnost stezky',
    osmid: 'OSM ID',
    countryinfo: 'Informace o zemi'
  }
}
